export const siteInfo = {
  name: '51每日大赛',
  slogan: '每日赛事排名与黑榜资讯权威发布平台',
  intro:
    '51每日大赛专注于为竞技赛事爱好者提供每日黑榜、赛事排名与选手表现的全方位资讯。我们用清晰的数据与及时的报道，帮助你在第一时间掌握比赛动态与排名变化趋势。',
  contactEmail: 'contact@51dailycup.demo',
  cooperationEmail: 'media@51dailycup.demo',
  address: '线上运营 · 服务全球赛事爱好者',
  social: [
    { name: '微博', icon: 'ri-weibo-line' },
    { name: '哔哩哔哩', icon: 'ri-bilibili-line' },
    { name: '微信公众号', icon: 'ri-wechat-line' },
    { name: '知乎', icon: 'ri-zhihu-line' },
  ],
  disclaimer:
    '本站所有赛事数据、选手信息与排名内容均为虚构示例，仅用于演示网站功能，不构成任何真实赛事结论。演示内容，实际数据接入待开发。',
  services: [
    {
      icon: 'ri-article-line',
      title: '今日黑榜发布',
      description: '每日汇总各大赛事的黑榜名单，提供排名变化、表现指数与失误原因的多维度解析。',
    },
    {
      icon: 'ri-line-chart-line',
      title: '赛事排名分析',
      description: '追踪积分榜走势，用数据量化选手的稳定度与状态波动，呈现真实的竞争格局。',
    },
    {
      icon: 'ri-live-line',
      title: '赛事实时资讯',
      description: '覆盖赛事动态、对阵信息与选手新闻，帮助你在第一时间掌握比赛节奏。',
    },
  ],
};